import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../web/components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: 12,
		width: '100%',
	},
	subtitle: {
		fontSize: 16,
		fontWeight: 600,
	},
	singleFrequencyText: {
		fontSize: THEME.typography.fontSizes.xl,
		fontWeight: THEME.typography.fontWeights.standard,
	},
	frequenciesContainer: {
		width: '100%',
		display: 'grid',
		gridTemplateColumns: 'repeat(2, 1fr)',
		gap: 12,

		'@media (min-width: 722px)': {
			gridTemplateColumns: 'repeat(4, 1fr)',
		},
	},
	frequencyButton: {
		width: '100%',
	},
});
